module.exports = __webpack_public_path__ + "img/Weilin Bingmo Refrigerator Food Management Software2.1a2c34d2.jpg";